import Box from '@mui/material/Box';

import { styles } from './styles';

const EmptyToolbar = () => {
  return <Box sx={styles.main} />;
};

export default EmptyToolbar;
